import { Component, EventEmitter, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SharedService } from '../../services/shared.service';
import { ShippingService } from '../../services/shipping.service';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css']
})
export class ShippingCreateComponent implements OnInit {
  dateEnd: any;
  dateStart: any;
  shippingTypeId: number = 1;
  notes: string;
  showOnlyNotSelectedItems: boolean = false;

  prescriptions: any[] = [];
  filteredPrescriptions: any[] = [];
  residents: string[] = [];
  selectedResident: string = '';

  shippingId: number = 0;
  shippingStatusPendingId: number = 1;
  shippingStatusSentId: number = 2;

  showLoadingMessage: boolean = false;
  showErrorMessage: boolean;
  errorMessage: string;

  @ViewChild('addCustomItemModal', { static: false }) addCustomItemModal: ElementRef;
  @Output() public onFacilityUnitChanged = new EventEmitter();
  facilityUnits: any[] = [];
  facilityUnitId: any = 0;
  facilityUnitIds: number[] = [];
  selectedFacilityUnitIds: number[] = [];

  customResident: string = '';
  customRxNum: number = null;
  customQuantity: number = 0;
  customMedication: string = '';

  get editMode(): boolean {
    return this.isEditMode();
  }

  constructor(private sharedService: SharedService,
    private shippingService: ShippingService,
    private route: ActivatedRoute,
    private router: Router,
    private datepipe: DatePipe) { }

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.loadDate();

    this.loadFacilityUnits();
    if (this.sharedService.facilityUnitId == null) {
      this.sharedService.facilityUnitId = 0;
      this.onFacilityUnitChanged.emit();
    }

    if (this.isEditMode()) {
      this.loadForm();
    } else {
      this.loadPrescriptions();
    }
  }

  isEditMode(): boolean {
    return this.route.snapshot.paramMap.get('id') != null;
  }

  loadForm() {
    this.showLoadingMessage = true;
    this.shippingId = Number.parseInt(this.route.snapshot.paramMap.get('id'));
    this.shippingService.getShipping(this.shippingId).subscribe(model => {
      this.dateStart = model.startDate;
      this.dateEnd = model.endDate;
      this.shippingTypeId = model.shippingTypeId;
      this.notes = model.notes;
      this.selectedFacilityUnitIds = model.facilityUnitIds;

      this.shippingService.getShippingPrescriptions(this.sharedService.pharmacyId, this.sharedService.facilityId, this.selectedFacilityUnitIds, this.shippingTypeId, model.startDate, model.endDate).subscribe(data => {
        this.prescriptions = data;
        this.filteredPrescriptions = data;
        this.residents = [...new Set(data.map(p => p.patientName))];
        for (let p of this.prescriptions) {
          var item = model.shippingItems.find(i => i.rxNum == p.rxNum);
          if (item != null) {
            p.selected = true;
            p.shippedAt = null;
          }
        }

        // Add missing shippingItems to prescriptions
        for (let item of model.shippingItems) {
          if (!this.prescriptions.some(p => p.rxNum === item.rxNum)) {
            this.prescriptions.push({
              ...item,
              selected: true,
              shippedAt: null
            });
          }
        }

        this.filteredPrescriptions = this.prescriptions;
        this.showLoadingMessage = false;
      }, err => this.showLoadingMessage = false);

      this.showLoadingMessage = false;
    }, err => this.showLoadingMessage = false);
  }

  public search() {
    if (this.shippingId > 0) {
      this.loadForm();
    }

    this.showErrorMessage = false;
    var resultFieldsValidation = this.validateDate();
    if (resultFieldsValidation.length == 0) {
      this.loadPrescriptions();
    } else {
      this.loadErrorMessage(resultFieldsValidation.join(" "));
    }
  }

  loadDate() {
    this.dateStart = new Date();
    this.dateEnd = new Date();
  }

  validateDate(): string[] {
    const errors: string[] = [];
    if (this.dateEnd < this.dateStart)
      errors.push("The End Date must be greater than Start Date!");

    //if (this.sharedService.facilityUnitId == 0)
    //  errors.push("Select a Facility Unit");

    if (!this.selectedFacilityUnitIds || this.selectedFacilityUnitIds.length === 0) {
      errors.push("Select at least one Facility Unit");
    }

    return errors;
  }

  clearErrorMessage() {
    this.showErrorMessage = false;
    this.errorMessage = "";
  }

  loadErrorMessage(message: any) {
    this.showErrorMessage = true;
    this.errorMessage = message.toString();
    window.scroll(0, 0);
  }

  private loadPrescriptions() {
    this.showLoadingMessage = true;
    var startDateText = this.datepipe.transform(this.dateStart, 'yyyy-MM-dd');
    var endDateText = this.datepipe.transform(this.dateEnd, 'yyyy-MM-dd');

    // Store custom items
    const customItems = this.prescriptions.filter(p => p.custom);

    this.shippingService.getShippingPrescriptions(this.sharedService.pharmacyId, this.sharedService.facilityId, this.selectedFacilityUnitIds, this.shippingTypeId, startDateText, endDateText).subscribe(data => {
      this.prescriptions = data;
      this.filteredPrescriptions = data;
      this.residents = [...new Set(data.map(p => p.patientName))];

      if (this.showOnlyNotSelectedItems)
        this.prescriptions = this.prescriptions.filter(p => p.shippedAt == null);

      // Merge custom items back into prescriptions
      this.prescriptions = [...this.prescriptions, ...customItems];
      this.filteredPrescriptions = this.prescriptions;

      this.showLoadingMessage = false;
    },
      err => this.showLoadingMessage = false);
  }

  filterPrescriptions() {
    if (this.selectedResident) {
      this.filteredPrescriptions = this.prescriptions.filter(p => p.patientName === this.selectedResident);
    } else {
      this.filteredPrescriptions = this.prescriptions;
    }
  }

  selectAllEvent(selected) {
    if (this.selectedResident) {
      this.prescriptions
        .filter(p => p.shippedAt == null && p.patientName === this.selectedResident)
        .forEach(p => { p.selected = selected });
    } else {
      this.prescriptions
        .filter(p => p.shippedAt == null)
        .forEach(p => { p.selected = selected });
    }
  }

  onRowClick(rxNum, drugRecordBook) {
    if (!drugRecordBook) {
      var prescription = this.prescriptions.find(p => p.rxNum == rxNum);
      if (prescription != null && prescription.shippedAt == null)
        prescription.selected = !prescription.selected;
    }
  }

  redirectToShipping() {
    if (this.sharedService.facilityId) {
      this.router.navigate(['shipping/']);
    }
  }

  getModel(shippingStatusId): any {
    var shipping: any = {
      id: this.shippingId,
      pharmacyId: this.sharedService.pharmacyId,
      facilityId: this.sharedService.facilityId,
      createdBy: this.sharedService.getUserId(),
      startDate: this.datepipe.transform(this.dateStart, 'yyyy-MM-dd'),
      endDate: this.datepipe.transform(this.dateEnd, 'yyyy-MM-dd'),
      shippingTypeId: Number.parseInt(this.shippingTypeId.toString()),
      shippingStatusId: shippingStatusId,
      notes: this.notes,
      shippingItems: this.prescriptions.filter(p => p.selected),
      shippingFacilityUnits: this.selectedFacilityUnitIds.map(id => ({
        FacilityUnitId: id,
        PharmacyId: this.sharedService.pharmacyId
      }))
    };

    return shipping;
  }

  validateFields(): string {
    var errors: string[] = [];
    var message: string = "";

    if (this.notes == null || this.notes.trim().length == 0)
      errors.push('Title');

    if (this.selectedFacilityUnitIds == null || this.selectedFacilityUnitIds.length == 0)
      errors.push('Unit');

    if (this.dateStart == null || this.dateEnd == null)
      errors.push('Date');

    if (this.shippingTypeId == null || this.shippingTypeId == 0)
      errors.push('Type');

    if (this.sharedService.facilityId == null || this.sharedService.facilityId == 0
      || this.sharedService.pharmacyId == null || this.sharedService.pharmacyId == 0)
      errors.push('Invalid request, please try close and open it again.');

    if ((this.prescriptions == null || this.prescriptions.filter(p => p.selected).length == 0))
      errors.push('Prescriptions');

    if (errors.length == 1) {
      message = "The field " + errors.join(", ") + " is mandatory."
    } else if (errors.length > 1) {
      message = "The fields " + errors.join(", ") + " are mandatory."
    }

    return message;
  }

  save(shippingStatusId) {
    try {
      this.clearErrorMessage();
      var resultFieldsValidation = this.validateFields();
      var model = this.getModel(shippingStatusId);

      if (resultFieldsValidation == "") {
        this.shippingService.save(model).subscribe(resultVo => {
          if (resultVo.success) {
            this.sharedService.showTempSuccessMessage();
            this.redirectToShipping();
          } else {
            this.loadErrorMessage(resultVo.message);
          }
        });
      } else {
        this.loadErrorMessage(resultFieldsValidation);
      }
    } catch (e) {
      this.loadErrorMessage(e);
    }
  }

  public exportToPdf() {
    var pageTitle = "Shipping";
    this.router.navigate([]).then(result => { window.open('report/Shipping/' + this.shippingId + '/' + pageTitle, '_blank'); });
  }

  public onShowOnlyNotSelectedItemsChanged() {
    if (this.showOnlyNotSelectedItems)
      this.prescriptions = this.prescriptions.filter(p => p.shippedAt == null);
    else {
      this.search();
    }
  }

  addCustomItem() {
    const newItem = {
      id: 0,
      shippingId: this.shippingId,
      pharmacyId: this.sharedService.pharmacyId,
      patientId: null, 
      patientName: this.customResident, 
      rxNum: this.customRxNum,
      quantity: this.customQuantity,
      medication: this.customMedication,
      directions: '', 
      selected: true,
      shippedAt: null,
      drugRecordBook: false,
      isWeeklyStrip: false,
      custom: true
    };

    this.prescriptions.push(newItem);
    this.filterPrescriptions();
    this.clearCustomItemFields();
    this.addCustomItemModal.nativeElement.click();
  }

  clearCustomItemFields() {
    this.customResident = '';
    this.customRxNum = null;
    this.customQuantity = null;
    this.customMedication = '';
  }

  onActionFacilityUnit() {
    this.onFacilityUnitChanged.emit();
  }

  loadFacilityUnits() {
    this.sharedService.getFacilityUnits()
      .subscribe(data => {
        this.facilityUnits = data;
      });
  }

  onFacilityUnitCheckboxChange(unitId: number, isChecked: boolean) {
    if (isChecked) {
      this.selectedFacilityUnitIds.push(unitId);
    } else {
      const index = this.selectedFacilityUnitIds.indexOf(unitId);
      if (index !== -1) {
        this.selectedFacilityUnitIds.splice(index, 1);
      }
    }
    // Emit or handle changes if necessary
    this.onFacilityUnitChanged.emit();
  }
}
